import type { ReportFactoryConfig } from '../reportFactoryTypes'
import type { PortfolioOption, SearchConditionsDraft } from '../types'

export const getPortfolioOptions = (
  config: ReportFactoryConfig
): PortfolioOption[] =>
  config.portfolios.map(({ portfolioId, sheetName }) => ({
    id: portfolioId,
    name: sheetName,
  }))

export const buildInitialConditions = (
  config: ReportFactoryConfig
): SearchConditionsDraft => {
  const groups = new Map<number, number[]>()
  for (const { portfolioId, benchmarkPercent } of config.portfolios) {
    const portfolioIds = groups.get(benchmarkPercent)
    if (portfolioIds) portfolioIds.push(portfolioId)
    else groups.set(benchmarkPercent, [portfolioId])
  }
  return {
    baseDate: '',
    rows: Array.from(groups, ([benchmarkPercent, portfolioIds], index) => ({
      rowId: `row-${index + 1}`,
      portfolioIds,
      benchmarkInput: String(benchmarkPercent),
    })),
    groupBy: config.defaults.groupBy === 'currency' ? 'Currency' : 'Class',
    isAppliedAccountMTD: config.defaults.isAppliedAccountMTD,
    useFullFundName: config.defaults.useFullFundName,
  }
}
